export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/settings.1b34fa50.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};